export var LOCAL_STORAGE_KEY = 'AUTOCOMPLETE_RECENT_SEARCHES';
export var LOCAL_STORAGE_KEY_TEST = '__AUTOCOMPLETE_RECENT_SEARCHES_PLUGIN_TEST_KEY__';
export var defaultTranslations = {
  removeSearchTitle: 'Remove this search',
  fillQueryTitle: function fillQueryTitle(text) {
    return "Fill query with \"".concat(text, "\"");
  }
};